import * as Sentry from '@sentry/nextjs';

const isProd =
  process.env.SENTRY_ENVIRONMENT === "production";

if(isProd){
  Sentry.init({
    dsn: 'https://b792509aa5d57456cc0bc642b92e3abf@sentry.hdfcergo.com/10',
    tracesSampleRate: 1,
    debug: false,
    environment: process.env.SENTRY_ENVIRONMENT || 'uat',
    release: process.env.NEXT_PUBLIC_RELEASE_VERSION || 'sentry-release',
  });
}

export const onRouterTransitionStart = isProd ? Sentry.captureRouterTransitionStart : () => {};
